var map = {
	"./icon-alert.svg": 3195,
	"./icon-big-athlete-a.svg": 67,
	"./icon-big-athlete.svg": 8553,
	"./icon-big-strong-a.svg": 115,
	"./icon-big-strong.svg": 3353,
	"./icon-chicken.svg": 7716,
	"./icon-info1.svg": 4532,
	"./icon-info2.svg": 2391,
	"./icon-lamb.svg": 1747,
	"./icon-medium-a.svg": 8504,
	"./icon-medium.svg": 7050,
	"./icon-puppy.svg": 615,
	"./icon-puppy2.svg": 1623,
	"./icon-salmon.svg": 9461,
	"./icon-small-a.svg": 9050,
	"./icon-small.svg": 9476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4733;